import { LanguageIconCell } from "@/molecules/LanguageIconCell"
import { ValueList } from "../ValueList"

import type { CVEIncident } from "@/domain/adr"

export const PackagesList = ({ record }: { record: CVEIncident }) => {
  const items = record.what.vulnerabilitiesMeta.packages.list

  return (
    <ValueList<{ name: string; language: Language }>
      limit={3}
      items={items}
      titleKey="general.package"
      render={(record) => {
        return LanguageIconCell(`${record.name}`, record)
      }}
    />
  )
}
